(function () {
  function init() {
    var bar = document.querySelector('.sticky-atc-mobile');
    if (!bar) return;

    var anchor = document.getElementById(bar.dataset.anchor);
    var mql = window.matchMedia('(max-width: 768px)');

    // Robuuste scroll-check: tonen zodra de koopknop volledig boven de viewport is verdwenen.
    // Vangnet: is de knop verborgen of onvindbaar (geen afmetingen), val terug op scroll-afstand.
    function shouldShow() {
      if (!mql.matches) return false;
      if (anchor) {
        var r = anchor.getBoundingClientRect();
        var hidden = r.width === 0 && r.height === 0;
        if (!hidden) return r.bottom < 0;
      }
      return window.scrollY > 700;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var show = shouldShow();
        bar.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('atc-bar-visible', show);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mql.addEventListener('change', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
